// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#settingsContent[data-v-635b86a5] {\n    padding: 0px 30px;\n}\n", ""]);
// Exports
module.exports = exports;
